import React from 'react'
import { Card, Space } from 'antd'
import { Passenger } from '../../../../services/api/orders'
import { Link } from 'react-router-dom'
import { employeePath } from '../../../../routes/paths'
import { Property } from '../../../../components'
import { displayDate } from '../../../../utils/formatter'

type Props = {
  passengers: Passenger[]
}

export const Passengers: React.FunctionComponent<Props> = ({ passengers }) => {
  return (
    <Space wrap size={10}>
      {passengers.map((passenger, i) => (
        <Card key={passenger.id} title="Пассажир" size="small">
          <Property label="ФИО">
            <Link to={employeePath(passenger.id)}>
              {passenger.firstNameRu} {passenger.lastNameRu}
            </Link>
          </Property>
          <Property label="Дата рождения">
            {displayDate(passenger.birthdate)}
          </Property>
          <Property label="Телефон">{passenger.phoneNumber}</Property>
        </Card>
      ))}
    </Space>
  )
}
